const BASE_VITAL_FIELDS = [
  { id: 'systolicBpInMmHg', label: 'Systolic blood pressure', unit: 'mmHg', decimals: 0, color: '#e11d48', priority: 1 },
  { id: 'diastolicBpInMmHg', label: 'Diastolic blood pressure', unit: 'mmHg', decimals: 0, color: '#7c3aed', priority: 2 },
  { id: 'bpm', label: 'Pulse', unit: 'bpm', decimals: 0, color: '#e11d48', priority: 3 },
  { id: 'sp02', label: 'Oxygen saturation', unit: '%', decimals: 0, color: '#0284c7', priority: 4 },
  { id: 'tempInCelsius', label: 'Temperature', unit: '°C', decimals: 1, color: '#ea580c', priority: 5 },
  { id: 'respiratoryRatePerMin', label: 'Respiratory rate', unit: '/min', decimals: 0, color: '#0891b2', priority: 6 },
  { id: 'weightInGrams', label: 'Weight', unit: 'kg', decimals: 1, color: '#4f46e5', priority: 7, divisor: 1000 },
  { id: 'bmi', label: 'BMI', unit: 'kg/m²', decimals: 1, color: '#7c3aed', priority: 8 },
  { id: 'heightInCms', label: 'Height', unit: 'cm', decimals: 1, color: '#6366f1', priority: 9 },
  { id: 'heightInMillimeters', label: 'Height', unit: 'cm', decimals: 1, color: '#6366f1', priority: 10, divisor: 10 },
  { id: 'rbsInMgPerDl', label: 'Random blood glucose', unit: 'mg/dL', decimals: 0, color: '#d97706', priority: 11 },
  { id: 'waistCircumferenceInCm', label: 'Waist circumference', unit: 'cm', decimals: 1, color: '#0f766e', priority: 12 },
  { id: 'hipCircumferenceInCm', label: 'Hip circumference', unit: 'cm', decimals: 1, color: '#0d9488', priority: 13 },
  { id: 'abdominalGirthInCm', label: 'Abdominal girth', unit: 'cm', decimals: 1, color: '#14b8a6', priority: 14 },
  { id: 'waistHipRatio', label: 'Waist–hip ratio', unit: '', decimals: 2, color: '#0f766e', priority: 15 },
  { id: 'bodyFatPercentage', label: 'Body fat', unit: '%', decimals: 1, color: '#db2777', priority: 16 },
  { id: 'visceralFat', label: 'Visceral fat level', unit: '', decimals: 1, color: '#be123c', priority: 17 },
  { id: 'subcutaneousFatPercentage', label: 'Subcutaneous fat', unit: '%', decimals: 1, color: '#f43f5e', priority: 18 },
  { id: 'fatMassInGrams', label: 'Fat mass', unit: 'kg', decimals: 1, color: '#e11d48', priority: 19, divisor: 1000 },
  { id: 'fatFreeBodyWeightInGrams', label: 'Fat-free body weight', unit: 'kg', decimals: 1, color: '#059669', priority: 20, divisor: 1000 },
  { id: 'muscleMassInGrams', label: 'Muscle mass', unit: 'kg', decimals: 1, color: '#16a34a', priority: 21, divisor: 1000 },
  { id: 'muscleRatePercentage', label: 'Muscle rate', unit: '%', decimals: 1, color: '#15803d', priority: 22 },
  { id: 'skeletalMusclePercentage', label: 'Skeletal muscle', unit: '%', decimals: 1, color: '#059669', priority: 23 },
  { id: 'proteinMassInGrams', label: 'Protein mass', unit: 'kg', decimals: 1, color: '#2563eb', priority: 24, divisor: 1000 },
  { id: 'proteinPercentage', label: 'Protein', unit: '%', decimals: 1, color: '#3b82f6', priority: 25 },
  { id: 'waterWeightInGrams', label: 'Body water weight', unit: 'kg', decimals: 1, color: '#0284c7', priority: 26, divisor: 1000 },
  { id: 'bodyWaterPercentage', label: 'Body water', unit: '%', decimals: 1, color: '#0ea5e9', priority: 27 },
  { id: 'boneMassInGrams', label: 'Bone mass', unit: 'kg', decimals: 2, color: '#64748b', priority: 28, divisor: 1000 },
  { id: 'bmrInKcal', label: 'Basal metabolic rate', unit: 'kcal/day', decimals: 0, color: '#f97316', priority: 29 },
  { id: 'bodyAge', label: 'Body age', unit: 'years', decimals: 0, color: '#8b5cf6', priority: 30 },
  { id: 'idealBodyWeightInGrams', label: 'Ideal body weight', unit: 'kg', decimals: 1, color: '#6366f1', priority: 31, divisor: 1000 },
  { id: 'cardiacIndex', label: 'Cardiac index', unit: 'L/min/m²', decimals: 2, color: '#dc2626', priority: 32 },
]

export const KNOWN_VITAL_FIELDS = Object.freeze(BASE_VITAL_FIELDS)

export const VITAL_DATE_FIELDS = Object.freeze([
  { id: 'lastMenstrualPeriod', label: 'Last menstrual period' },
  { id: 'expectedDateOfDelivery', label: 'Expected delivery date' },
  { id: 'gestationAgeInDays', label: 'Gestational age', unit: 'days' },
])

export const VITAL_RANGE_OPTIONS = Object.freeze([
  { id: '30d', label: '30D', days: 30 },
  { id: '90d', label: '3M', days: 90 },
  { id: '1y', label: '1Y', days: 365 },
  { id: 'all', label: 'All', days: null },
])

const META_KEYS = new Set([
  'id', '_id', 'userId', 'patientId', 'clinicId', 'bookedEventId', 'clinicBrandId',
  'recordedBy', 'recordedByName', 'recordManagedBy', 'createdAt', 'createdTime',
  'modifiedAt', 'modifiedTime', 'time', 'type', 'category', 'meditationId', 'guidance',
  'sampleDuration', 'completedCycles', 'dateOfBirth', 'gender', 'placeOfBirth',
  'observedAt', 'recordSource', 'unitNormalizationVersion', 'displayUnitsByVitalId',
  'canonicalUnitsByVitalId', 'unitNormalizationSource', 'unitMigrationId', 'unitMigratedAt',
])

const COLORS = ['#4f46e5', '#0284c7', '#059669', '#d97706', '#db2777', '#7c3aed']

function titleFromKey(key) {
  return String(key)
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .replace(/\b\w/g, (letter) => letter.toUpperCase())
}

function getDefaultUnit(field) {
  const units = Array.isArray(field?.units) ? field.units : []
  return units.find((unit) => unit?.default || unit?.isDefault) || units[0] || null
}

export function getVitalTimestamp(vital) {
  const raw = vital?.observedAt || vital?.time || vital?.createdTime || vital?.modifiedTime || vital?.createdAt || vital?.modifiedAt
  if (!raw) return null
  const timestamp = new Date(String(raw).replace(' ', 'T') + (/Z|[+-]\d\d:?\d\d$/.test(String(raw)) ? '' : 'Z')).getTime()
  return Number.isFinite(timestamp) ? timestamp : null
}

export function getVitalFieldDefinitions(vitals = [], configuredFields = []) {
  const knownById = new Map(KNOWN_VITAL_FIELDS.map((field) => [field.id, field]))
  const configuredById = new Map((configuredFields || []).filter((field) => field?.id).map((field) => [field.id, field]))
  const discoveredIds = new Set()

  vitals.forEach((vital) => {
    Object.entries(vital || {}).forEach(([key, value]) => {
      if (!META_KEYS.has(key) && typeof value === 'number' && Number.isFinite(value)) {
        discoveredIds.add(key)
      }
    })
  })

  return [...new Set([...configuredById.keys(), ...knownById.keys(), ...discoveredIds])]
    .map((id, index) => {
      const configured = configuredById.get(id) || {}
      const known = knownById.get(id) || {}
      const unitSpec = getDefaultUnit(configured)
      return {
        ...configured,
        ...known,
        id,
        label: configured.label || known.label || titleFromKey(id),
        unit: known.unit || unitSpec?.label || unitSpec?.code || configured.baseUnit || '',
        decimals: known.decimals ?? unitSpec?.decimals ?? 1,
        color: known.color || COLORS[index % COLORS.length],
        priority: known.priority ?? 100 + (configured.order ?? index),
      }
    })
    .filter((field) => vitals.some((vital) => Number.isFinite(Number(vital?.[field.id]))))
    .sort((a, b) => a.priority - b.priority)
}

export function toVitalDisplayValue(field, rawValue) {
  const numeric = Number(rawValue)
  if (!Number.isFinite(numeric)) return null
  if (field?.divisor) return numeric / field.divisor

  const unit = getDefaultUnit(field)
  const conversion = unit?.toBase
  if (conversion && conversion.kind !== 'linearCombo' && Number.isFinite(Number(conversion.factor))) {
    return (numeric - Number(conversion.offset || 0)) / Number(conversion.factor)
  }
  return numeric
}

export function formatVitalValue(field, value) {
  const numeric = Number(value)
  if (!Number.isFinite(numeric)) return '—'
  const decimals = field?.decimals ?? 1
  const formatted = new Intl.NumberFormat('en-IN', {
    maximumFractionDigits: decimals,
    minimumFractionDigits: decimals === 0 ? 0 : Math.min(1, decimals),
  }).format(numeric)
  return `${formatted}${field?.unit ? ` ${field.unit}` : ''}`
}

export function getBloodPressureInterpretation(systolic, diastolic, context = {}) {
  const sys = Number(systolic)
  const dia = Number(diastolic)
  if (!Number.isFinite(sys) && !Number.isFinite(dia)) return null
  if (Number.isFinite(context.patientAge) && context.patientAge < 18) {
    return { label: 'Paediatric context required', tone: 'neutral', note: 'Blood-pressure percentiles depend on age, sex and height; review an age-specific reference.' }
  }
  const ranges = { systolicBpInMmHg: [90, 120], diastolicBpInMmHg: [60, 80] }
  if (sys > 180 || dia > 120) return { label: 'Severely high', tone: 'critical', note: 'AHA adult category; assess symptoms and repeat appropriately.', ranges }
  if (sys >= 140 || dia >= 90) return { label: 'Stage 2 range', tone: 'high', note: 'AHA adult blood-pressure category.', ranges }
  if (sys >= 130 || dia >= 80) return { label: 'Stage 1 range', tone: 'attention', note: 'AHA adult blood-pressure category.', ranges }
  if (sys >= 120 && dia < 80) return { label: 'Elevated range', tone: 'attention', note: 'AHA adult blood-pressure category.', ranges }
  if (sys < 90 || dia < 60) return { label: 'Below general range', tone: 'low', note: 'Interpret with symptoms, baseline and clinical context.', ranges }
  return { label: 'Within general range', tone: 'normal', note: 'General adult reference; diagnosis requires repeated readings.', ranges }
}

export function getVitalReference(fieldId, context = {}) {
  const isPaediatric = Number.isFinite(context.patientAge) && context.patientAge < 18
  const isUnderTwenty = Number.isFinite(context.patientAge) && context.patientAge < 20
  switch (fieldId) {
    case 'blood-pressure':
      if (isPaediatric) return { summary: 'Use paediatric percentiles', explainer: 'Blood-pressure percentiles depend on age, sex and height; adult bands are not shown.', ranges: null }
      return {
        summary: 'General adult: 90–<120 / 60–<80 mmHg',
        explainer: 'The higher category of systolic or diastolic pressure determines the adult AHA category. Repeated readings and clinical context are required.',
        ranges: { systolicBpInMmHg: [90, 120], diastolicBpInMmHg: [60, 80] },
      }
    case 'bpm':
      if (isPaediatric) return { summary: 'Use age-specific resting ranges', explainer: 'Expected resting heart rate changes through childhood and adolescence.', ranges: null }
      return { summary: 'General adult resting: 60–100 bpm', explainer: 'Activity, fitness, medicines, rhythm and symptoms can change the appropriate target.', ranges: { bpm: [60, 100] } }
    case 'sp02':
      return { summary: 'Usual reference: 95–100%', explainer: 'Device quality, perfusion, altitude and conditions such as COPD can change the expected target.', ranges: { sp02: [95, 100] } }
    case 'tempInCelsius':
      return { summary: 'Approximate adult oral: 36.1–37.5°C', explainer: 'Measurement site, device, technique and time of day materially affect temperature.', ranges: { tempInCelsius: [36.1, 37.5] } }
    case 'respiratoryRatePerMin':
      if (isPaediatric) return { summary: 'Use age-specific resting ranges', explainer: 'Expected respiratory rate changes through childhood and adolescence.', ranges: null }
      return { summary: 'General adult resting: 12–20/min', explainer: 'Count at rest and interpret with effort, oxygenation, medicines and symptoms.', ranges: { respiratoryRatePerMin: [12, 20] } }
    case 'bmi':
      if (isUnderTwenty) return { summary: 'Use BMI-for-age percentiles', explainer: 'For ages 2–19, BMI is interpreted by age- and sex-specific percentile rather than adult bands.', ranges: null }
      return { summary: 'Adult healthy-weight screening band: 18.5–<25', explainer: 'BMI is a screening measure and is not diagnostic; pregnancy, muscle mass and body composition matter.', ranges: { bmi: [18.5, 25] } }
    case 'rbsInMgPerDl':
      return { summary: 'Interpret with meal timing and symptoms', explainer: 'A random glucose value has no single universal target. Diagnostic interpretation depends on symptoms, repeat testing and the patient’s treatment plan.', ranges: null }
    default:
      return { summary: 'Patient-specific reference', explainer: 'No single general range applies reliably; interpret the trend against age, sex, device, condition and treatment goals.', ranges: null }
  }
}

export function getVitalInterpretation(fieldId, value, context = {}) {
  const numeric = Number(value)
  if (!Number.isFinite(numeric)) return null
  const isPaediatric = Number.isFinite(context.patientAge) && context.patientAge < 18
  const isUnderTwenty = Number.isFinite(context.patientAge) && context.patientAge < 20
  switch (fieldId) {
    case 'bpm':
      if (isPaediatric) return { label: 'Age-specific range', tone: 'neutral', note: 'Resting heart-rate ranges change through childhood and adolescence.' }
      if (numeric < 60) return { label: 'Below resting range', tone: 'low', note: 'General adult resting reference: 60–100 bpm; athletes and medicines may differ.', range: [60, 100] }
      if (numeric > 100) return { label: 'Above resting range', tone: 'high', note: 'General adult resting reference: 60–100 bpm; interpret with activity and symptoms.', range: [60, 100] }
      return { label: 'Within resting range', tone: 'normal', note: 'General adult resting reference: 60–100 bpm.', range: [60, 100] }
    case 'sp02':
      if (numeric <= 88) return { label: 'Markedly low reading', tone: 'critical', note: 'Verify signal quality and interpret with the patient’s target and condition.', range: [95, 100] }
      if (numeric <= 92) return { label: 'Low reading', tone: 'high', note: 'General reference; COPD, pneumonia and altitude may change the expected target.', range: [95, 100] }
      if (numeric < 95) return { label: 'Below usual range', tone: 'attention', note: 'Most healthy people are 95–100%; device error can be several points.', range: [95, 100] }
      return { label: 'Within usual range', tone: 'normal', note: 'General reference for most healthy people: 95–100%.', range: [95, 100] }
    case 'tempInCelsius':
      if (numeric < 35) return { label: 'Low reading', tone: 'high', note: 'Measurement site and method materially affect temperature.', range: [36.1, 37.5] }
      if (numeric > 37.5) return { label: 'Above general oral range', tone: numeric >= 39 ? 'high' : 'attention', note: 'Measurement site, time of day and clinical context affect interpretation.', range: [36.1, 37.5] }
      return { label: 'Within general range', tone: 'normal', note: 'Approximate adult oral reference; site and time of day vary.', range: [36.1, 37.5] }
    case 'respiratoryRatePerMin':
      if (isPaediatric) return { label: 'Age-specific range', tone: 'neutral', note: 'Resting respiratory-rate ranges change through childhood and adolescence.' }
      if (numeric < 12) return { label: 'Below resting range', tone: 'low', note: 'General adult resting reference: 12–20 breaths/min.', range: [12, 20] }
      if (numeric > 20) return { label: 'Above resting range', tone: 'high', note: 'General adult resting reference: 12–20 breaths/min.', range: [12, 20] }
      return { label: 'Within resting range', tone: 'normal', note: 'General adult resting reference: 12–20 breaths/min.', range: [12, 20] }
    case 'bmi':
      if (isUnderTwenty) return { label: 'BMI-for-age required', tone: 'neutral', note: 'For ages 2–19, interpret BMI using age- and sex-specific percentiles.' }
      if (numeric < 18.5) return { label: 'Underweight screening range', tone: 'attention', note: 'Adult BMI screening category; do not apply to children or pregnancy.', range: [18.5, 25] }
      if (numeric < 25) return { label: 'Healthy-weight screening range', tone: 'normal', note: 'Adult BMI is a screening measure, not a diagnosis.', range: [18.5, 25] }
      if (numeric < 30) return { label: 'Overweight screening range', tone: 'attention', note: 'Adult BMI is a screening measure; assess alongside other factors.', range: [18.5, 25] }
      return { label: 'Obesity screening range', tone: 'high', note: 'Adult BMI is a screening measure; assess alongside other factors.', range: [18.5, 25] }
    case 'rbsInMgPerDl':
      if (numeric >= 200) return { label: 'High random reading', tone: 'high', note: 'Interpret with symptoms, meal timing, repeat testing and the patient’s diabetes plan.' }
      return { label: 'Context required', tone: 'neutral', note: 'Random glucose has no single universal target; consider meal timing and the patient’s plan.' }
    default:
      return { label: 'Trend-focused', tone: 'neutral', note: 'Reference ranges depend on age, sex, device, setting or treatment goal.' }
  }
}

export function getToneColors(tone) {
  return {
    normal: { fg: '#047857', bg: '#ecfdf5', border: '#a7f3d0' },
    attention: { fg: '#a16207', bg: '#fffbeb', border: '#fde68a' },
    high: { fg: '#c2410c', bg: '#fff7ed', border: '#fed7aa' },
    critical: { fg: '#be123c', bg: '#fff1f2', border: '#fecdd3' },
    low: { fg: '#0369a1', bg: '#f0f9ff', border: '#bae6fd' },
    neutral: { fg: '#475569', bg: '#f8fafc', border: '#e2e8f0' },
  }[tone] || { fg: '#475569', bg: '#f8fafc', border: '#e2e8f0' }
}

export function sampleTrendPoints(points, limit = 40) {
  if (!Array.isArray(points) || points.length <= limit) return points || []
  const sampled = []
  const step = (points.length - 1) / (limit - 1)
  for (let index = 0; index < limit; index += 1) {
    sampled.push(points[Math.round(index * step)])
  }
  return sampled
}

export function getTimeSeriesRatio(timestamp, startTimestamp, endTimestamp) {
  const value = Number(timestamp)
  const start = Number(startTimestamp)
  const end = Number(endTimestamp)
  if (![value, start, end].every(Number.isFinite)) return 0.5
  if (end <= start) return 0.5
  return Math.max(0, Math.min(1, (value - start) / (end - start)))
}

export function findNearestTimePointIndex(points, targetTimestamp) {
  if (!Array.isArray(points) || points.length === 0) return -1
  const target = Number(targetTimestamp)
  if (!Number.isFinite(target)) return points.length - 1

  let nearestIndex = 0
  let nearestDistance = Math.abs(Number(points[0]?.timestamp) - target)
  for (let index = 1; index < points.length; index += 1) {
    const distance = Math.abs(Number(points[index]?.timestamp) - target)
    if (Number.isFinite(distance) && distance < nearestDistance) {
      nearestDistance = distance
      nearestIndex = index
    }
  }
  return nearestIndex
}

export function isVitalObjectValid(vitalItem) {
  return Boolean(vitalItem && getVitalFieldDefinitions([vitalItem]).length > 0)
}
